import React, {Component} from "react";
import EventHelper from "../../helpers/EventHelper";
import FactorsHelper from "../../helpers/FactorsHelper";
import {connect} from "react-redux";
import {delCoupon} from "../../redux/actions/coupon";

class Bets extends Component {
	betDelete(eventId) {
		this.props.onDelCoupon('live', eventId);
	}

	render() {
		const {bets} = this.props;

		const data = Object.entries(bets).map(([eventId, bet]) => {
			const event = {
				id : eventId,
				sport_id : bet.sportId,
				team1 : bet.team1,
				team2 : bet.team2
			};

			const factorsHelper = new FactorsHelper(event, [], this.props.factorsSettings);
			const parsedBet = factorsHelper.parseBet(bet);

			return (
				<div className="coupon__content__bets__bet">
					<i className="fas fa-times bet-delete" onClick={this.betDelete.bind(this, eventId)}></i>
					<div className="bet-players">
						{EventHelper.parseTeams(bet.team1, bet.team2)}
					</div>
					<div className="bet-desc">
						<div className="bet-type">
							{bet.p > 0 && <span>{factorsHelper.printPeriod(bet.p)}: </span>}
							{parsedBet.text}
						</div>
						<div className={`bet-koeff koeff-${bet.fStatus}`}>{bet.v}</div>
					</div>
				</div>
			);
		});

		return (
			<div className="coupon__content__bets">
				{data}
			</div>
		);
	}
}

export default connect(
	state => ({
		factorsSettings : state.main.factors
	}),
	dispatch => ({
		onDelCoupon : (type, eventId) => {
			dispatch(delCoupon(type, eventId));
		}
	})
)(Bets);


// WEBPACK FOOTER //
// ./src/app/components/Coupon/Bets.js